import React, { Component } from "react";
import { connect } from 'react-redux';
import { 
    Row,
    Col,
    Card,
    CardBody,
    Button
} from 'reactstrap';

import {Tbl, TblHead, TblBody} from '../../../components/Tbl';
import Paginations from '../../../components/Paginations/Paginations';
import PaginationSummaries from '../../../components/Paginations/PaginationSummaries';
import FilterPanel from './Filters';
import FilterContainer from '../../../components/Container/FilterContainer/FilterContainer';
import { CardHeaderWithToolbars,Title } from '../../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars'

import { generateNumber } from '../../../utils';
import { DEFAULT_SORT_BY } from '../../../constants/settings';
import privateView from '../../../components/hocs/privateView';
import Analytics from "../../../services/Analytics";
import CheckReadOnly from "../../../components/CheckReadOnly";
import { getArticleMetalList } from "../../../actions/articleAction";
import ModalArticleMetaForm from "./ModalArticleMetaForm";

const dataHeader=[
  'No.', 'Name', 'Content', 'Action'
];

const defaultParams = {
  sort_by : DEFAULT_SORT_BY,
  per_page : 5
}

class ArticleMetaIndex extends Component {
  constructor() {
    super();
    this.state = {
      _params: {
        ...defaultParams,
      },
      _id: "",
      _edit: false,
      _modalMeta: false,
      _filterOpen: false,
    };
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(
      this
    );
    this._handleGoto = this._handleGoto.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._modalMetaToggle = this._modalMetaToggle.bind(this)
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    this._getList(this.state._params);
    Analytics.recordPageView("article_meta_list", email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match,
    });
  }

  _toggleFilterPanel() {
    this.setState({ _filterOpen: !this.state._filterOpen });
  }

  _handleToggleFilterPanel(e) {
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _modalMetaToggle(update = false) {
    console.log('update please -->', update)
    this.setState({
      _id: "",
      _edit: false,
      _modalMeta: !this.state._modalMeta
    },()=>{
      if(update)
        this._refreshList()
    })
  }

  _onRenderRowItem(){
    if(this.props.article.meta.list.status_code===200 && this.props.article.meta.list.data.length>0){
      const { current_page,per_page } =  this.props.article.meta.list;
      return this.props.article.meta.list.data.map((item,index)=>
        (
          <tr key={generateNumber(per_page,current_page,index)}>
            <th scope="row">{ generateNumber(per_page,current_page,index) }</th>	
            <td>{ item.name }</td>
            <td>{ item.pivot.content }</td>
            <td>
              <Button color="success" onClick={() => {
                this.setState({
                  _id: item.id,
                  _edit: !!item.id,
                  _modalMeta: !this.state._modalMeta,
                })
              }}><i className="fa fa-edit"></i></Button>
            </td>
          </tr>
        )
      )	
    }
    return null;
  }

   /**
	 * Function to handle rendering paginations
	 * @author haikal
	 */
  _onRenderPagination(){
    const { list } = this.props.article.meta;
    const hasData = (list.status_code===200&&list.data.length) || null;
    return hasData && (
      <Paginations 
        size="sm" 
        lastPage={this.props.article.meta.list.last_page} 
        perPage={this.props.article.meta.list.per_page}
        total={this.props.article.meta.list.total}
        maxPage={8}
        path={this.props.article.meta.list.path}
        currentPage={this.props.article.meta.list.current_page} 
        prevPageUrl={this.props.article.meta.list.prev_page_url} 
        nextPageUrl={this.props.article.meta.list.next_page_url} 
        handleGotoCallback={this._handleGoto}
      />
    )
  }

	/**
	 * Handle callback when user click pagination items
	 * @author haikal
	 * @param {integer} page 
	 */
	_handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList(this.props.articleId, {params});
  }

  _refreshList(){
    const {page, ..._params} = this.state._params;
    this.setState({
      _params
    },()=>this._getList(this.state._params));
  }

  _handleParamsChange(e){
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    // Exclude page...
    const { page , ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });    
  }

  _handleDisplayChange(e){
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    _params.page = 1;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });    
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleResetFilter(e){
    e.preventDefault();
    const newState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...newState,
      _params:{
        ...defaultParams
      }
    },()=>this._getList(this.state._params));
  }
    
  render(){
    return(
      <div className="animated fadeIn">
        <Row>
          <ModalArticleMetaForm
            articleId={this.props.articleId}
            edit={this.state._edit}
            metaId={this.state._id} 
            isOpen={this.state._modalMeta}
            toggle={this._modalMetaToggle}
          />
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Article Meta List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel 
                  {...this.state._params} 
                  onHandleChange={this._handleParamsChange}
                  onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
                  onHandleSearch={this._handleRefresh}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <div className="mb-3">
                  <Button title="Create New" onClick={() => {
                    this.setState({
                      _id: "",
                      _edit: false,
                      _modalMeta: !this.state._modalMeta,
                    })
                  }}><i className="fa fa-plus"></i> Create New</Button>
                </div>
                <div className="table-responsive">
                  <PaginationSummaries
                    from={this.props.article.meta.list.from}
                    to={this.props.article.meta.list.to}
                    total={this.props.article.meta.list.total}
                  />
                  <Tbl>
                    <TblHead
                      dataHeader={dataHeader}
                    />
                    <TblBody
                      isLoad={this.props.article.meta.isFetch}
                      hasRow={this.props.article.meta.list.status_code===200&&this.props.article.meta.list.data.length>0}
                      columnCount={dataHeader.length}
                    >
                    { this._onRenderRowItem() }
                    </TblBody>
                  </Tbl>
                </div>
                { this._onRenderPagination() }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps= ({ article, auth: { isFetch, roles, isLogged, id, email } }) => {
	return {
    article,
    guardData: { isFetch, roles, isLogged, id, email }
	}
};
const mapDispatchToProps = (dispatch) => {
	return{
		getList:(article_id, query) => dispatch(getArticleMetalList(article_id, query))
	}

};
const enhance = connect(mapStateToProps,mapDispatchToProps);

export default enhance(privateView(ArticleMetaIndex, ['blog_admin']));
